import React from "react";
import SecondaryNavbar from "../HomePage/Navbar/SecondaryNavbar";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";

import { useLanguage } from "../../context/LanguageContext";

import dataEn from "../../languages/en/forgotPass.json";
import dataTh from "../../languages/th/forgotPass.json";

const ForgotPass = () => {
  const { selectedLanguage } = useLanguage(); // Use the context
  const data = selectedLanguage === "en" ? dataEn : dataTh;

  const [email, setEmail] = useState("");
  const [isEmailValid, setEmailValid] = useState(true);
  const [isFormSubmitted, setFormSubmitted] = useState(false);

  const validateEmail = (email) => {
    // Simple email validation regex
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!validateEmail(email)) {
      setEmailValid(false);
      return;
    } else {
      setEmailValid(true);
    }
    console.log("Email:", email);
    // Redirect to Email Notification Page
    handleOpenEmail();
  };

  const navigate = useNavigate();
  const handleOpenEmail = () => {
    navigate("/emailNotification", {
      state: { forgotpass: true },
    });
  };

  return (
    <div className="relative">
      <SecondaryNavbar />
      <div className="max-w-lg mx-auto mt-8 p-4 bg-white rounded-lg">
        <h2 className="text-2xl font-bold mb-4">{data.title}</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="mb-12">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700"
            >
              {data.email} <span className="text-red-500">*</span>
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              placeholder={data.emailPlaceHolder}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`mt-1 block w-full shadow-sm sm:text-sm rounded-lg p-2 pl-6 border 
              ${
                isFormSubmitted && !isEmailValid
                  ? "border-red-500"
                  : "border-gray-400"
              }`}
            />
            {isFormSubmitted && !isEmailValid && (
              <p className="mt-2 text-sm text-red-500">{data.formSubmitted}</p>
            )}
            <p className=" text-xs text-gray-400 mt-6">
              {data.paragraphs[0]} <br /> {data.paragraphs[1]}
            </p>
          </div>
          <button
            type="submit"
            className={`flex items-center justify-center w-full 
            bg-gradient-to-r from-primary-900 to-primary-600 text-white py-4 
            rounded-full font-bold hover:bg-blue-600
          
            `}
          >
            {data.submit}
          </button>
        </form>

        {/* make arrow and button gray to back  */}
        <div className="flex items-center justify-start mt-8">
          <AiOutlineArrowLeft className="text-gray-900" />
          <button
            onClick={() => navigate("/login")}
            className="text-gray-400 hover:text-gray-700 ml-2"
          >
            {data.login}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPass;
